/**
 * Dev-only warning emitted when both `render` and `xstyle` are provided.
 *
 * Components treat `render` and `xstyle` as mutually exclusive: `render` replaces
 * the entire element (consumer has full control), while `xstyle` applies typed
 * style overrides on top of defaults. When both are provided, `xstyle` is silently
 * ignored at runtime, and this warning surfaces the mistake in the console.
 *
 * The TypeScript types enforce this via a `never` union (passing both is a
 * compile error), but this warning catches misuse from `any` casts, and edge
 * cases where types are bypassed.
 *
 * Tree-shaken to zero bytes in production via the `process.env.NODE_ENV` guard.
 */
import { devLog } from './devLog';
export function warnMutuallyExclusive(componentName, render, xstyle) {
  if (render != null && xstyle != null) {
    devLog(`${componentName}: \`xstyle\` is ignored when \`render\` is provided. ` + 'Use `render` for full element control, or `xstyle` for typed style overrides — not both.');
  }
}